// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yTm5K{background:#e6edef;display:block;overflow:hidden;padding-bottom:60%;position:relative}.n4vMz{padding-bottom:0}.QhAlD{width:224px}.wprUO{background:none}._ZBf_{color:#fff;font-size:14px;min-height:155px;min-width:100%;position:absolute;width:100%}.ZfH1Y{height:132px;min-height:132px;-o-object-fit:cover;object-fit:cover;position:relative}.ZGcWm{border-radius:.75rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `yTm5K`,
	"root_trip": `n4vMz`,
	"root_similarListing": `QhAlD`,
	"root_rounded": `wprUO`,
	"image": `_ZBf_`,
	"image_trip": `ZfH1Y`,
	"image_rounded": `ZGcWm`
};
module.exports = ___CSS_LOADER_EXPORT___;
